jQuery(function () {
    (function ($, d3) {
        const containers = document.querySelectorAll('.qp-container'),
            firstConfig = JSON.parse(containers[0].getAttribute('data-config')); // Default config from first item (there may be more)

        var regexGuid =
            /^(\{){0,1}[0-9a-fA-F]{8}(\-){0,1}[0-9a-fA-F]{4}(\-){0,1}[0-9a-fA-F]{4}(\-){0,1}[0-9a-fA-F]{4}(\-){0,1}[0-9a-fA-F]{12}(\}){0,1}$/gi;
        $.getCachedScript = function (url, options) {
            // https://api.jquery.com/jquery.getscript/
            // Allow user to set any option except for dataType, cache, and url
            options = $.extend(options || {}, {
                dataType: 'script',
                cache: true,
                url: url
            });
            // Use $.ajax() since it is more flexible than $.getScript
            // Return the jqXHR object so we can chain callbacks
            return $.ajax(options);
        };

        // GUID - AGOL map, deal with that...
        if (regexGuid.test(firstConfig.map)) {
            containers.forEach((container, idx) => {
                container.setAttribute('class', container.getAttribute('class') + ' qp-container--' + idx);
                const config = JSON.parse(container.getAttribute('data-config')),
                    searchInput = container.querySelector('.qp-search-input'),
                    mapContainer = container.querySelector('.qp-map'),
                    mapPanel = document.createElement('div'),
                    tooltip = document.createElement('div'),
                    targetLayerIndex = config.layer !== undefined ? config.layer : 1;
                //searchInput.setAttribute('id', searchInput.getAttribute('id') + 'i' + idx);
                if (searchInput !== null) searchInput.addEventListener('keyup', debounce(search_input_handler, 300));
                mapContainer.appendChild(mapPanel);
                mapPanel.setAttribute('id', 'iaMap_' + config.map);
                mapPanel.setAttribute(
                    'style',
                    'position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 9999;'
                );
                tooltip.setAttribute('id', 'iaMap_' + config.map + '_root_mapTip');
                tooltip.setAttribute('class', 'tooltip agoMapTip mapTooltip qp-map-tooltip ia-map-tooltip');
                tooltip.appendChild(document.createElement('span'));
                tooltip.firstChild.setAttribute('class', 'mapTooltipText map-tooltip-text tooltip-text');
                mapContainer.appendChild(tooltip);
                window.instantAtlasMapping
                    .drawMap(config.map, mapPanel.getAttribute('id'), {
                        activeLayerIndex: targetLayerIndex,
                        scalebar: {
                            units: 'metric'
                        },
                        sliderStyle: config.map_controls ? 'small' : 'none',
                        sliderPosition: 'top-right',
                        sliderOrientation: 'horizontal',
                        tooltips: {
                            enabled: true,
                            field: config.name_prop || 'NAME'
                        },
                        navigate: {
                            enabled: true,
                            field: config.id_prop || 'WardCode',
                            path: config.action.replace('{{id_prop}}', '#ID')
                        }
                    })
                    .then((e) => {
                        const tile = container.closest('.tile');
                        if (tile !== null)
                            tile.setAttribute('class', (tile.getAttribute('class') || '').replace(/tile-loading/g, ''));
                        if (e !== undefined && e.layer !== undefined) {
                        }
                    });
            });
        }
        // Fallback is the SVG version but that sucks...
        else if (containers !== null && containers.length > 0) {
            try {
                tile = containers.item(0).closest('.tile-quickprofile');
                searchInput = containers.item(0).querySelector('.qp-search-input'); //$('.qp-search-input');
                tooltip = d3.select('.qp-container').append('div').attr('class', 'qp-map-tooltip');
                mapContainer = document.querySelector('.qp-map');
                if (!firstConfig.map_controls) $(mapContainer).children('.qp-map-controls').remove();
                // Override for code in the PHP because it simplifies rollout!
                if (firstConfig.title)
                    tile.children('.tile-inner').children('.tile-theme-name').text(firstConfig.title);
                if (firstConfig.description)
                    containers.item(0).find('.qp-search-container .qp-label').text(firstConfig.description);
                //search_input.on('keyup', debounce(search_input_handler, 300));
                if (searchInput !== null) searchInput.addEventListener('keyup', debounce(search_input_handler, 300));
                d3.json(firstConfig.map, function (err, data) {
                    if (err) return err;
                    draw_svg_map(data);

                    // Remove loading state if the quickprofile is in a tile
                    if (tile !== null)
                        tile.setAttribute('class', (tile.getAttribute('class') || '').replace(/tile-loading/g, ''));

                    $(window).on(
                        'resize',
                        debounce(function (e) {
                            draw_svg_map(data);
                        })
                    );
                });
            } catch (svgErr) {
                console.debug('Error setting up SVG map: ' + svgErr);
            }
        }

        function draw_svg_map(data) {
            $(mapContainer).children().not('.qp-map-controls').remove();

            var width = mapContainer.clientWidth;
            var height = mapContainer.clientHeight;

            /**
             * Background layers
             */

            var base_layer = firstConfig.base_layer || 'Canvas/World_Light_Gray_Base';
            var reference_layer = firstConfig.reference_layer || 'Canvas/World_Light_Gray_Reference';
            var background_base_url =
                '//server.arcgisonline.com/arcgis/rest/services/{{layer}}/MapServer/export?bbox={{bbox}}&bboxSR=4326&layers=&layerDefs=&size={{size}}&imageSR=102100&format=png&transparent=true&dpi=72&time=&layerTimeOptions=&dynamicLayers=&gdbVersion=&mapScale=&f=json';

            var svg = d3
                .select(mapContainer)
                .append('svg')
                .attr('width', width)
                .attr('height', height)
                .attr('viewBox', '0 0 ' + width + ' ' + height)
                .attr('preserveAspectRatio', 'xMinYMin')
                .style('cursor', 'move');

            var bounds;

            var centerMech = firstConfig.center_using || 'center';
            var center = d3.geoCentroid(data);
            if (centerMech != 'centroid') {
                bounds = d3.geoBounds(data);
                center = [
                    bounds[0][0] + (bounds[1][0] - bounds[0][0]) / 2.0,
                    bounds[0][1] + (bounds[1][1] - bounds[0][1]) / 2.0
                ];
            }

            var scale = 1;

            var projection = d3
                .geoMercator()
                .scale(scale)
                .center(center)
                .translate([width / 2, height / 2]);

            var path = d3.geoPath().projection(projection);

            // Zoom and center
            // using the path determine the bounds of the current map and use
            // these to determine better values for the scale and translation
            bounds = path.bounds(data);
            var hscale = 1 * ((scale * width) / (bounds[1][0] - bounds[0][0]));
            var vscale = 1 * ((scale * height) / (bounds[1][1] - bounds[0][1]));
            var scale = hscale < vscale ? hscale : vscale;
            var offset = [width - (bounds[0][0] + bounds[1][0]) / 2, height - (bounds[0][1] + bounds[1][1]) / 2];

            // Shrink a little bit to avoid getting cut off at the sides
            scale *= 0.9;

            // new projection
            projection = d3.geoMercator().center(center).scale(scale).translate(offset);

            path = path.projection(projection);

            var background_base = svg
                .append('image')
                .attr('x', 0)
                .attr('y', 0)
                .attr('width', width)
                .attr('height', height)
                .attr('class', 'qp-backgound-base-map')
                .on('error', function (e) {
                    // If there is an error display nothing
                    this.setAttribute('href', '');
                });

            var map_layer = svg
                .append('g')
                .selectAll('path')
                .data(data.features)
                .enter()
                .append('path')
                .attr('d', path)
                .attr('class', 'qp-map-feature')
                .attr('data-code', function (d) {
                    return d.properties[firstConfig.id_prop];
                });

            var background_reference = svg
                .append('image')
                .attr('x', 0)
                .attr('y', 0)
                .attr('width', width)
                .attr('height', height)
                .attr('class', 'qp-background-reference-map')
                .on('error', function (e) {
                    // If there is an error display nothing
                    this.setAttribute('href', '');
                });

            map_layer.on('mouseover', function (d, i) {
                var x = d3.event.offsetX; //d3.event.clientX;
                var y = d3.event.offsetY; //d3.event.clientY;
                var name = d.properties[firstConfig.name_prop];

                tooltip.html(name);
                tooltip.style('opacity', 1);
                tooltip.style('left', x + 'px');
                tooltip.style('top', y + 'px');
            });

            map_layer.on('mousemove', function (d, i) {
                var x = d3.event.offsetX; //d3.event.clientX;
                var y = d3.event.offsetY; //d3.event.clientY;
                tooltip.style('opacity', 1);
                tooltip.style('left', x + 'px');
                tooltip.style('top', y + 'px');
            });

            map_layer.on('mouseout', function (d, i) {
                tooltip.style('opacity', 0);
            });

            map_layer.on('click', function (d, i) {
                window.location = interpolate_action(firstConfig.action, firstConfig.id_prop, d);
                d3.event.stopImmediatePropagation();
            });

            var map_layers = [map_layer, background_base, background_reference];

            /**
             * Fetch & draw background layers initial
             */

            var bbox = projection.invert([0, 0]).concat(projection.invert([width, height]));
            var size = [width * 2, height * 2];

            var url = background_base_url.replace('{{bbox}}', bbox.join(',')).replace('{{size}}', size.join(','));

            var base_url = base_layer != 'none' ? url.replace('{{layer}}', base_layer) : null;
            var reference_url = reference_layer != 'none' ? url.replace('{{layer}}', reference_layer) : null;

            if (base_url != null) {
                $.get(base_url).done(function (res) {
                    var href = (typeof res === 'object' ? res : JSON.parse(res)).href;
                    if (href) {
                        background_base.attr('xlink:href', href);
                    }
                });
            }

            if (reference_url != null) {
                $.get(reference_url).done(function (res) {
                    var href = (typeof res === 'object' ? res : JSON.parse(res)).href;
                    if (href) {
                        background_reference.attr('xlink:href', href);
                    }
                });
            }

            /**
             * Setup a simple map pan and zoom for each visible layer
             * if the zoom option is set
             *
             * Warning: This feature is still in development
             */

            if (firstConfig.zoom) {
                var zoom = d3
                    .zoom()
                    .scaleExtent([1, 6])
                    .translateExtent([
                        [0, 0],
                        [width, height]
                    ])
                    .filter(function () {
                        return d3.event.ctrlKey;
                    });
                /*
                // Setup special mouse handling to enable click instead of pan unless the mouse moves mouseMoveThreshold many pixels
                var mouseDowned = false, mouseDownCoords, mouseDownEvent, mouseMoveThreshold = 5;
                svg.select('g').on('mousedown.highlight', function() 
                {
                    mouseDowned = true;
                    mouseDownEvent = new MouseEvent(d3.event.type, d3.event);
                    mouseDownCoords = [mouseDownEvent.x, mouseDownEvent.y];
                    // do not propagate this mousedown to zoom immediately - we will fake it with the mouseDownEvent if the mouse moves far enough.
                    d3.event.stopPropagation();
                });
                svg.on('mouseup.highlight click.highlight', function()
                {
                    mouseDowned = false;
                });
                function lineLength(a, b) {
                    return Math.sqrt(Math.pow(a[0] - b[0], 2) + Math.pow(a[1] - b[1], 2));
                }
                svg.on('mousemove.highlight', function()
                {
                    // skip tracking mouse move if we didn't mousedown on the highlight item
                    if (!mouseDowned) return;
                    var mouse = [d3.event.x, d3.event.y];
                    var distance = lineLength(mouse, mouseDownCoords);
                    if (distance > mouseMoveThreshold) 
                    {
                        mouseDowned = false;
                        svg.node().dispatchEvent(mouseDownEvent);
                    }
                });
*/
                var update_bg = debounceD3Event(function (transform) {
                    background_base.attr('class', 'qp-backgound-base-map layer-refreshing');
                    background_reference.attr('class', 'qp-backgound-reference-map layer-refreshing');
                    var proj = d3
                        .geoMercator()
                        .center(projection.center())
                        .scale(projection.scale())
                        .translate(projection.translate());

                    var pt = proj.translate();
                    var scale = proj.scale() * transform.k;
                    var tx = pt[0] * transform.k + transform.x;
                    var ty = pt[1] * transform.k + transform.y;

                    proj.translate([tx, ty]).scale(scale);

                    var bbox = proj.invert([0, 0]).concat(proj.invert([width, height]));
                    var size = [width, height];

                    var url = background_base_url
                        .replace('{{bbox}}', bbox.join(','))
                        .replace('{{size}}', size.join(','));

                    var base_url = base_layer != 'none' ? url.replace('{{layer}}', base_layer) : null;
                    var reference_url = reference_layer != 'none' ? url.replace('{{layer}}', reference_layer) : null;

                    if (base_url != null) {
                        $.get(base_url).done(function (res) {
                            var href = (typeof res === 'object' ? res : JSON.parse(res)).href;
                            if (href) {
                                background_base.attr('xlink:href', href);
                            }
                            background_base.attr('class', 'qp-backgound-base-map');
                        });
                    }

                    if (reference_url != null) {
                        $.get(reference_url).done(function (res) {
                            var href = (typeof res === 'object' ? res : JSON.parse(res)).href;
                            if (href) {
                                background_reference.attr('xlink:href', href);
                            }
                            background_reference.attr('class', 'qp-backgound-reference-map');
                        });
                    }
                }, 100);
                svg.call(
                    zoom.on('zoom', function () {
                        var transform = d3.event.transform;
                        map_layer.attr('transform', transform).style('stroke-width', 1 / transform.k + 'px');
                        update_bg(transform);
                    })
                );
                $(mapContainer).addClass('map-zoomable');

                var map_controls = mapContainer.querySelector('.qp-map-controls');

                if (map_controls) {
                    /**
                     * Show the controls
                     */
                    map_controls.style = 'display: block';

                    /**
                     * Bind the controls to zoom
                     */
                    var in_button = map_controls.querySelector('.qp-map-zoom-in');
                    var out_button = map_controls.querySelector('.qp-map-zoom-out');

                    in_button.addEventListener('click', function () {
                        zoom.scaleBy(svg, 1.2);
                    });

                    out_button.addEventListener('click', function () {
                        zoom.scaleBy(svg, 0.8);
                    });
                }
            }
        }

        function interpolate_action(action, id_prop, obj) {
            var action = action.replace('{{id_prop}}', obj.properties[id_prop]);
            return action;
        }

        function debounce(func, wait) {
            var timeout;
            return function () {
                var context = this,
                    args = arguments;
                var later = function () {
                    timeout = null;
                    func.apply(context, args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        }

        /**
         * Takes a string as input and attempts to format it as a postcode
         * returns false if it fails
         */

        function format_postcode(pc) {
            var pc = pc.toUpperCase();
            postcode = pc.match(pc_regexp());
            if (postcode instanceof Array) {
                postcode.shift();
                return postcode.join(' ');
            }
            return false;
        }

        function pc_regexp() {
            return new RegExp(/^([A-Z]{1,2}\d{1,2}[A-Z]?)\s*(\d[A-Z]{2})$/);
        }

        function build_arcgis_query(str, lookup_field) {
            var base_endpoint =
                firstConfig.lookupUrl ||
                'https://ons-inspire.esriuk.com/arcgis/rest/services/Postcodes/ONS_Postcode_Directory_Latest_Centroids/MapServer/0/';
            var query =
                'query?where=' +
                encodeURIComponent("pcds = '" + str + "'") +
                '&outFields=' +
                (lookup_field || 'osward') +
                '&f=json';
            return base_endpoint + query;
        }

        function noop() {}

        function debounceD3Event(func, wait, immediate) {
            var timeout;
            return function () {
                var context = this;
                var args = arguments;
                var evt = d3.event;

                var later = function () {
                    timeout = null;
                    if (!immediate) {
                        var tmpEvent = d3.event;
                        d3.event = evt;
                        func.apply(context, args);
                        d3.event = tmpEvent;
                    }
                };

                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) {
                    var tmpEvent = d3.event;
                    d3.event = evt;
                    func.apply(context, args);
                    d3.event = tmpEvent;
                }
            };
        }

        function throttleD3Event(func, limit) {
            var wait = false;
            return function () {
                var evt = d3.event;
                var args = arguments;
                var context = this;
                if (!wait) {
                    var tmpevt = d3.event;
                    d3.event = evt;
                    func.apply(context, args);
                    d3.event = tmpevt;
                    wait = true;
                    setTimeout(function () {
                        wait = false;
                    }, limit);
                }
            };
        }

        function search_input_handler(e) {
            const $searchInput = $(
                e.currentTarget !== undefined && e.currentTarget !== null ? e.currentTarget : e.target
            );
            var stripped = $.trim($searchInput.val());
            var search_str = format_postcode(stripped.toUpperCase());

            /**
             * Build the query
             */
            var lookup_field = firstConfig.lookup_field || 'osward';
            var lookup = build_arcgis_query(search_str, lookup_field);

            /**
             * Handle the enter key
             */
            if (e.keyCode === 13) {
                /**
                 * Handle case where the postcode doesnt validate
                 */
                if (!search_str || search_str.length < 6) {
                    $('.qp-search-error')
                        .text('The postcode you entered is invalid, please try again.')
                        .addClass('active');
                    return;
                }
                $('.qp-search-input').addClass('loading');
                $.get(lookup, function (data) {
                    var json = typeof data === 'object' ? data : JSON.parse(data);
                    var lookup_code;
                    try {
                        lookup_code = json.features[0].attributes[lookup_field];
                    } catch (err) {
                        $('.qp-search-input').removeClass('loading');
                        $('.qp-search-error')
                            .text('The postcode ' + search_str + ' did not match an area. Please try again.')
                            .addClass('active');
                        return;
                    }

                    window.location = firstConfig.action.replace('{{id_prop}}', lookup_code);
                });
            }
        }
    })(jQuery, d3);
});
